import React, { useMemo, useState } from 'react';
import { Modal } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import competentProfessionalSelect from '../../services/competentProfessionalSelect.service';
import './newRow.css';
import { Col, Form, Row, Table } from 'react-bootstrap';
import debounce from 'lodash.debounce';
const tableHeadings = ['name', 'qualifications', 'relevant_experience', 'email', 'phone'];
const CompetentProfessionalSelectModal = _ref => {
  let {
    show,
    onHide,
    setTableData,
    tableData,
    forNewProjectCreation = false,
    addCompetentProfessionalToNewProject = null,
    newProjectCompetentProfessionals = null,
    claimGroup = null
  } = _ref;
  const {
    t
  } = useTranslation();
  const [data, selectCompetentProfessional, setData, report_id] = competentProfessionalSelect.useCompetentProfessionalSelect(show, forNewProjectCreation);
  const [searchQuery, setSearchQuery] = useState(null);
  const fetchNewProjectCompetentProfessionals = competentProfessionalSelect.useGetNewProjectClaimGroupCompetentProfessionals(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.id, setData);
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });
  const searchByQuery = useMemo(() => debounce(competentProfessionalSelect.useGetCompetentProfessionals, 1500), []);
  const search = e => {
    setSearchQuery(e.target.value);
    searchByQuery(setData, report_id, e.target.value);
  };
  const onSearch = forNewProjectCreation ? e => fetchNewProjectCompetentProfessionals(e.target.value) : search;
  const finalTableData = forNewProjectCreation ? data.filter(competentProfessional => !newProjectCompetentProfessionals.some(addedCompetentProfessional => addedCompetentProfessional.id === competentProfessional.id)) : data;
  const tableRows = finalTableData.map(competentProfessional => {
    const rowOnClick = forNewProjectCreation ? () => addCompetentProfessionalToNewProject(competentProfessional) : () => selectCompetentProfessional(competentProfessional.id, data, setTableData, tableData);
    return /*#__PURE__*/React.createElement("tr", {
      className: "cursor-pointer table-row",
      onClick: rowOnClick
    }, tableHeadings.map(propertyName => {
      return /*#__PURE__*/React.createElement("td", null, competentProfessional[propertyName]);
    }));
  });
  const renderBody = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('search')), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: searchQuery,
    name: 'search_query',
    onChange: onSearch,
    size: "md",
    type: "text"
  })))), /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows)));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('select_competent_professional'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    closeText: t('close')
  });
};
export default CompetentProfessionalSelectModal;